import { ref } from 'vue'
import { sendCaptcha } from '@/api/main'

export default function useCountDown() {
  const timer: any = ref(null)
  const rawText = '获取验证码'
  const rawCount = 60
  const count: any = ref(rawText)
  const counting = ref(false)
  const countDown = (type,params, done) => {
    if (counting.value) return
    counting.value = true
    clearCountDown()
    sendCaptcha(type,params).then((res: any) => {
      if (res.code == 200) {
        Xinnet.message.success(res.res || '发送成功')
      } else {
        Xinnet.message.error(res.msg)
      }
    })

    count.value = rawCount
    timer.value = setInterval(() => {
      if (count.value >= 1) {
        --count.value
      }
      if (count.value < 1) {
        clearCountDown()
        count.value = rawText
        counting.value = false
        if (done) {
          done()
        }
      }
    }, 1000)
  }

  const clearCountDown = () => {
    clearInterval(timer.value)
    timer.value = null
  }

  return {
    count,
    counting,
    countDown
  }
}
